import { loginOTPChangePassword } from 'api/change-password'

import { ErrorOTPChangePassword } from 'assets/icons'

import LoadingSpinner from 'components/loadingSpinner/LoadingSpinner'
import Logo from 'components/logo'
import PrimaryButton from 'components/primaryButton'

import { storageKey } from 'constants/storage'
import WORDING from 'constants/wording'

import { MeContext } from 'contexts/me'
import { UserContext } from 'contexts/user'

import React, { useState, useEffect, useContext } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import storage from 'utils/storage'

const OTPChangePassword = () => {
  const [isError, setIsError] = useState(false)
  const [counter, setCounter] = useState(false)
  const [searchParams] = useSearchParams()

  const { setUser } = useContext(UserContext)

  const { me } = useContext(MeContext)
  const navigate = useNavigate()
  const { WAIT, OOPS, SECONDS, ERROR, REDIRECT, BUTTON_REDIRECT } = WORDING

  useEffect(() => {
    let interval
    if (isError && counter > 0) {
      interval = setInterval(
        () => setCounter((prevState) => prevState - 1),
        1000
      )
    }
    if (counter === 0) {
      navigate('/', { replace: true })
    }
    return () => clearInterval(interval)
  }, [isError, counter])

  useEffect(() => {
    if (me) {
      navigate('/cambiar-contrasena', { replace: true })
    }
  }, [me])

  useEffect(() => {
    const tokenOTP = searchParams.get('otp-token')
    const passwordToken = searchParams.get('password-token')
    if (tokenOTP && passwordToken) {
      loginOTPChangePassword(tokenOTP).then((data) => {
        if (data.success) {
          storage.set(storageKey.USER, data.data || null)
          storage.set('password_token', passwordToken || null)
          setUser(data.data)
        } else {
          setIsError(true)
          setCounter(15)
        }
      })
    }
  }, [])

  return (
    <div className='flex flex-col h-screen'>
      <header className='shadow-sm w-full h-14 bg-white  md:py-4 flex items-center justify-center'>
        <div className='flex items-center'>
          <Logo showAlways />
        </div>
      </header>
      <div className='mt-20 px-3 h-full w-full max-w-564 mx-auto'>
        {isError ? (
          <section className='flex flex-col items-center md:max-w-564 mx-auto gap-2 h-full'>
            <h1 className='font-bold text-black text-4xl'>{OOPS}</h1>
            <p className='font-bold text-gray-900 text-xl'>{ERROR}</p>
            <div className='py-6'>
              <ErrorOTPChangePassword />
            </div>
            <div className='text-center mx-2 font-medium text-gray-900 text-base leading-relaxed'>
              <p>
                {REDIRECT}{' '}
                <span className='font-bold'>
                  {counter} {SECONDS}
                </span>
                .
              </p>
              <p className='mt-2'>{BUTTON_REDIRECT}</p>
            </div>
            <div className='mt-8 w-full'>
              <PrimaryButton
                className='w-full'
                buttonText='Ir a configuración'
                primaryButtonFunction={() =>
                  navigate('/configuracion', { replace: true })
                }
              />
            </div>
          </section>
        ) : (
          <>
            <div className='mt-10 sm:mt-2'>
              <LoadingSpinner
                width='w-60'
                height='h-60'
                loadingMessage='Redireccionando'
              />
            </div>
            <p className='text-center font-medium text-gray-900 text-xs mt-2 mb-4'>
              {WAIT}
            </p>
          </>
        )}
      </div>
    </div>
  )
}

export default OTPChangePassword
